import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {AgyleTable, createAgyleTableColumn} from "../../components/table/AgyleTable";
import makeStyles from "@mui/styles/makeStyles";
import moment from "moment/moment";
import Paper from "@mui/material/Paper";
import React, {useEffect, useState} from 'react';
import API from "../../app/api";
import _ from "lodash";
import clsx from "clsx";
import { IconButton, TextField} from '@mui/material';
import AgyleToggleButtons from "../../components/ui/buttons/agyleToggleButtons";
import {
    clearWorkListFilters,
    getAdmissionType,
    getConfig, getFilterConsultantWorklist, getFilterPatientWorklist,
    getFilterPriorityWorklist,
    getFilterSpecialityWorklist, getFilterWhoCanOperateWorklist,
    getWorklistOperations,
    handleOperationClick, setFilterConsultantWorklist, setFilterPatientWorklist,
    setFilterPriorityWorklist,
    setFilterSpecialityWorklist, setFilterWhoCanOperateWorklist,
    setMarkedOperation,
    setOperationsStatus,
    setWorklistOperationsData,
} from '../../store/reducers/booked_admissions';
import {admissionStatusTypes, admissionViewTypes, bookAdmissionToggleStyles} from '../bookedAdmissions/bookedAdmissions';
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import Grid from '@mui/material/Grid';
import {
    AdmissionConsultantDropdown,
    AdmissionSpecialtiesDropdown,
} from '../../controls/agyle/dictionaries';
import AgyleDictionaryField from '../../components/ui/selector/agyleDictionaryField';
import Typography from '@mui/material/Typography';
import {setSnackbar} from '../../store/reducers/globals';
import {useHistory} from 'react-router-dom';
import EditIcon from '@mui/icons-material/Edit';
import {HeaderPrintModal} from '../bookedAdmissions/header/bookedAdmissionsHeader';
import useOpenState from '../../hooks/useOpenState';
import PrintIcon from '@mui/icons-material/Print';
import Chip from '@mui/material/Chip';
import AgyleSelectField from '../../components/ui/selector/agyleSelectField';
import MenuItem from '@mui/material/MenuItem';
import Box from '@mui/material/Box';
import {hasBAPermission, hasPermission, Permissions, user} from '../../store/reducers/user';
import DeleteIcon from "@mui/icons-material/Delete";
import ContentPasteGoIcon from '@mui/icons-material/ContentPasteGo';
import MessageBox from '../../util/messageBox';
import AgyleTextField from '../../components/ui/fields/agyleTextField';
import AgyleMultiselectDropdown from '../../components/ui/selector/agyleMultiselectDropdown';
import LockTimeSlotModal from '../bookedAdmissions/content/modals/lockTimeSlotModal';
import AgyleDialog from '../../components/modal/agyleDialog';
import AgyleButton from '../../components/ui/buttons/agyleButton';
import Checkbox from '@mui/material/Checkbox';
import {FilterIcon2} from '../../components/icons/icons';
import CloseIcon from '@mui/icons-material/Close';
import {useDebounce} from 'use-debounce';
import SearchIcon from "@mui/icons-material/Search";
import {Tooltip} from '@material-ui/core';
import AgyleSwitch from '../../components/ui/switch/agyleSwitch';
import Switch from '@mui/material/Switch';
import {agylePref} from '../../store/reducers/preferences';

const useStyles = makeStyles((theme) => ({
    // bookAdmissionToggle_classNameRoot: {
    //     color: theme.palette.mode === "dark" ? "black" : "#f3f3f4",
    //     backgroundColor: theme.palette.mode === "dark" ? "#b0b0b0" : "#bfc2c7",
    // },
    // bookAdmissionToggle_classNameLabel: {
    //     color: theme.palette.mode === "dark" ? "black" : "#f3f3f4",
    // },
    // bookAdmissionToggle_classNameSelected: {
    //     color: theme.palette.mode === "dark" ? "black !important" : "#ffffff !important",
    //     fontWeight:  theme.palette.mode === "dark" ? 400 : 600,
    //     backgroundColor: theme.palette.mode === "dark" ? "#ffffff !important" : "#626466 !important"
    // },
    paper: {
        backgroundColor: theme.palette.mode === "dark" ? "#252525" : "#eff1f3",
        backgroundImage: "none",
       // marginTop: 15,
        borderRadius: 10,
        padding: 0
    },
    inputPropsClasses: {
        fontSize: 15,
    },
    headCell: {
        padding: "2px 2px 2px 16px",
        background: theme.palette.mode === "dark" ? "#3D3E40" : "#dee1e5",
        color: theme.palette.mode === "dark" ? "#ACAFB3" : "#626466",
        borderStyle: "solid",
        borderColor: theme.palette.mode === "dark" ? "#3D3E40" : "#dee1e5",
        borderWidth: "4px 0px 4px 0px",
        "&:first-child": {
            borderRadius: "8px 0px 0px 8px",
            borderWidth: "4px 0px 4px 4px"
        },
        "&:last-child": {
            borderRadius: "0px 8px 8px 0px",
            borderWidth: "4px 4px 4px 0px"
        }
    },
    headerRow: {
        //border: "8px solid black",
        //borderRadius: "4px",
        //background: "#3D3E40",
        color:"#ACAFB3",
        height: "48px"
    },
    tableRow: {
        background: theme.palette.mode === "dark" ? "#333333" : "#FFFFFF",
        "&:hover": {
            background: theme.palette.mode === "dark" ? "#3D3E40" : "#e3e3e3",
        },
    },
    fontRobo: {
        fontFamily: "Roboto",
        fontStyle: "normal",
        fontWeight: 400,
        fontSize: "12px",
        lineHeight: "14px"
    },
    menuItem: {
        padding: 0,
        fontSize: 12,
    },
    filterName: {
        fontSize: 15,
        fontWeight: 800,
        marginBottom: 23
    },
    fontInter: {
        fontFamily: "Inter",
        fontStyle: "normal",
        fontWeight: 400,
        fontSize: "12px",
        lineHeight: "15px"
    },
    procedure: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        padding: "0px 0px 8px 0px",
        gap: "5px",
        color: theme.palette.mode === "dark" ? "#FFFFFF" : "#5f6162",
    },
    notes: {
        flexDirection: "column",
        alignItems: "flex-start",
        padding: "0px",
        gap: "5px",
        color: theme.palette.mode === "dark" ? "#FFFFFF" : "#5f6162",
        maxWidth: "20vw"
    },
    procedureRowTop: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        padding: "0px",
        gap: "10px",
        color: theme.palette.mode === "dark" ? "#FFFFFF" : "#5f6162",
    },
    procedureRowTopTime: {
        gap: "4px",
    },
    procedureRowTopTimeIcon: {
        fontSize: theme.palette.mode === "dark" ? "24px" : "20px",
    },
    cell: {
        paddingTop: "16px",
        paddingBottom: "16px",
        paddingLeft: "16px",
        borderStyle: "solid",
        borderColor: "transparent" ,//theme.palette.mode === "dark" ? "black" : "white",
        borderWidth: "4px 0px 4px 0px",
        verticalAlign: "top",
        "&:first-child": {
            borderRadius: "8px 0px 0px 8px",
            borderWidth: "4px 0px 4px 4px"
        },
        "&:last-child": {
            borderRadius: "0px 8px 8px 0px",
            borderWidth: "4px 4px 4px 0px"
        }
    },
    procedureSpec: {
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-start",
        padding: "4px 6px",
        gap: "10px",
        borderWidth: "1px",
        borderStyle: "solid",
        borderColor: theme.palette.mode === "dark" ? "#FFFFFF" : "#5f6162",
        borderRadius: "6px"
    },
    patient: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        padding: "0px",
        gap: "8px"
    },
    recCount: {
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-start",
        padding: "4px 6px",
        gap: "10px",
        // width: "26px",
        height: "23px",
        background: theme.palette.mode === "dark" ? "#3D3E40" : "#DEE1E5",
        borderRadius: "6px",
        //marginLeft: "10px"
    },
    recCountA: {
        gap: "61px",
        width: "150px",
        display: "flex",
        alignItems: "center",
        paddingLeft: "5px",
        flexDirection: "row",
        fontSize: 14
    },
    recCountB: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: "8px",
        // width: "142px",
        height: "23px",
        marginLeft: "8px"
    },
    priorityDescription:{
        borderRadius: 7,
        background: "gray",
        padding: 4,
        fontWeight: "bold",
        display: "inline-block"
    },
    dialogContentStyle: {
        backgroundColor: theme.palette.mode === "dark" ? "#252525" : "#f2f2f2"
    },
    clearFilterButton: {
        color: "#2180F7",
        fontSize: 12,
        display: "inline-flex",
        alignItems: "center",
        cursor: "pointer"
    },
}));

export const procedureLenString = (procedureLen, timeFormatInMinutes = false) => {
    let len = procedureLen ;
    if (len === 0) {
        return "0 min";
    }
    const duration = moment.duration(len, 'minutes');
    const hours = timeFormatInMinutes? 0 :Math.floor(duration.asHours());
    const leftMinutes = len - (hours*60);
    let timeString = "";

    if(hours>0) timeString += `${hours}Hrs `;
    if(leftMinutes>0) timeString += `${leftMinutes}min `;

    return timeString;
}

export const proceduresLenStringTotalTime = (admission, timeFormatInMinutes = false) => {
    let len = 0 ;
    _.forEach(admission.proceduresLen, (procedure) => {
        len = len + procedure
    })

    if (len === 0) {
        return "0 min";
    }
    const duration = moment.duration(len, 'minutes');
    const hours = timeFormatInMinutes? 0 :Math.floor(duration.asHours());
    const leftMinutes = len - (hours*60);
    let timeString = "";

    if(hours>0) timeString += `${hours}Hrs `;
    if(leftMinutes>0) timeString += `${leftMinutes}min `;

    return timeString;
}

export const proceduresLenMinTotalTime = (procedures) => {
    let len = 0 ;
    _.forEach(procedures, (procedure) => {
        _.forEach(procedure.systype, (st) => {
            len = len + st.duration
        });
    })

   return len? len: 60
}

export const proceduresLen = (admission) => {
    let len = 0;
    _.forEach(admission?.proceduresLen, (procedure) => {
        len = len + procedure
    })

    return len;
}

const defaultRequestOptions = {
    "$filter": "",
    "$page": 1,
    "$pageSize": 50,
    "$sort": "createdDate",
};


function WorkList(props) {
    const dispatch = useDispatch();
    const {t, i18n} = useTranslation();
    const classes = useStyles();
    const baToggleClasses = bookAdmissionToggleStyles();
    const [listData, setListData] = React.useState([]);
    const [options, setOptions] = React.useState(defaultRequestOptions);

    const admissionType = useSelector(getAdmissionType);
    const admissionConfig = useSelector(getConfig);
    const worklistOperations = useSelector(getWorklistOperations);

    const priorityFilter = useSelector(getFilterPriorityWorklist);
    const specialtiesFilter = useSelector(getFilterSpecialityWorklist);
    const ovsConsultantFilter = useSelector(getFilterConsultantWorklist)
    const whoCanOperateFilter =  useSelector(getFilterWhoCanOperateWorklist)
    const patientFilter = useSelector(getFilterPatientWorklist);
    const agylePreference = useSelector(agylePref);

    const [isPrintModalOpen, openPrintModal, closePrintModal] = useOpenState(false, true);
    const [isConfirmModalOpen, openConfirmModal, closeConfirmModal] = useOpenState(false, true);
    const [isFiltersModalOpen, openFiltersModal, closeFiltersModal] = useOpenState(false, true);

    const [isDeletedView, setDeletedView] = useState(false);

    const [input, setInput] = useState(patientFilter);
    const [inputValueDebounced] = useDebounce(input, 1000);

    useEffect(()=>{
        dispatch(setFilterPatientWorklist(inputValueDebounced))
    }, [inputValueDebounced])

    const filtersAreSet = () => {
        return specialtiesFilter.length || ovsConsultantFilter.length || whoCanOperateFilter.length || priorityFilter.length || input.length
    }

    const clearFilters = () => {
        dispatch(clearWorkListFilters());
        setInput("")
    }

    const getWorklistOperationsSorted = () => {
        return _.orderBy(worklistOperations, o => sort.type === "number" ? Number(_.get(o, sort.field)) : _.get(o, sort.field), [sort.order])
    }

    useEffect(() => {
        loadWorklistOperations();
    }, [specialtiesFilter, ovsConsultantFilter, whoCanOperateFilter, priorityFilter, patientFilter, isDeletedView]);

    const getFilter = () => {
        let filter = `opType in '["TCI"]' `;
        filter += `and status in '["WORKLIST","WORKLIST_AND_CALENDAR"]' `;

        if(isDeletedView) {
            let date  = moment().add(-28, "days").format("YYYY-MM-DD");
            filter += `and (cancelInfo.status eq 'delete' and cancelInfo.date gt_dt '${date}') `;
        } else {
            filter += `and (cancelInfo ex 0 or cancelInfo.status eq 'rebook')`
        }

        if(patientFilter && patientFilter.length > 0) {
            let filterArray = patientFilter.split(" ");

            let pattern = /\d{2}\/\d{2}\/\d{4}/;
            let hospitalNumbers = filterArray.filter((f) => f.match(/[0-9]/)).filter((f) => !f.match(pattern));
            let dob = filterArray.filter((f) => f.match(pattern));
            let names = filterArray.filter((f) => !f.match(/[0-9]/)).filter((f) => !f.match(pattern));

            if(hospitalNumbers) {
                filter += ` and patientId regex '(?i)(?:${hospitalNumbers.join("|")})'`;
            }
            if(dob.length) {
                let dobString = moment(dob, "MM/DD/YYYY").format("YYYY-MM-DD")
                filter += ` and patientDob eq_dt '${dobString}' `;
            }

            if(names.length) {
                filter += ` and patientName regex '(?i)(?:.*${names.join(".*|.*")}.*)'`;
            }
        }
        if (specialtiesFilter && specialtiesFilter.length > 0) {
            if(!filter) filter = "";
            else filter += " AND ";
            filter += `procedures.specialty in '[`


            specialtiesFilter.forEach((p, index) => {
                if(index > 0) filter += ","
                filter += `"${p.__code}"`
            })
            filter += `]'`
        }

        if (ovsConsultantFilter && ovsConsultantFilter.length > 0) {
            if(!filter) filter = "";
            else filter += " AND ";
            filter += `overseeingConsultant.id in '[`


            ovsConsultantFilter.forEach((p, index) => {
                if(index > 0) filter += ","
                filter += `"${p.id}"`
            })
            filter += `]'`

        }

        if (whoCanOperateFilter && whoCanOperateFilter.length > 0) {
            if(!filter) filter = "";
            else filter += " AND ";
            filter += `whoCouldOperate.code in '[`


            whoCanOperateFilter.forEach((p, index) => {
                if(index > 0) filter += ","
                filter += `"${p}"`
            })
            filter += `]'`
        }

        if (priorityFilter && priorityFilter.length > 0) {
            if(!filter) filter = "";
            else filter += " AND ";
            filter += `priority.code in '[`


            priorityFilter.forEach((p, index) => {
                if(index > 0) filter += ","
                filter += `"${p}"`
            })
            filter += `]'`
        }

        // return encodeURIComponent(filter);
        return filter;
    }


    const loadWorklistOperations = () => {
        let filter = getFilter()

        API.getOperation(filter).then(res=>{
            dispatch(setWorklistOperationsData(res));
        });
    }


    const patientCell = (column,data) => {
        let age = "Unknown";
        if(data.patientDob) {
            const birthDate = moment(data.patientDob);
            age = moment().diff(birthDate, 'years');
        }
        return (
            <div className={clsx({[classes.patient]: true,[classes.fontRobo]: true})}>
                <div>{data.patientId}; Age: {age}</div>
                <div>{data.patientName}</div>
                {data.patient?.dod && <div style={{color: "red"}}> DECEASED </div>}
            </div>
        );
    }

    const signalSubmit = new AbortController();
    const userObject = useSelector(user);

    const [operationToDelete, setOperationToDelete] = React.useState(null);

    const deleteOperation = () => {

        if(deleteReason?.length > 2) {
            let operationTmp = _.cloneDeep(operationToDelete);

            if(operationTmp.status === "WORKLIST") {

                delete operationTmp.sessiosObj;
                delete operationTmp.patient;
                delete operationTmp.href;
                delete operationTmp.type;

                //operationTmp.status = "WORKLIST_AND_CALENDAR";

                operationTmp.cancelInfo = {
                    lastBookedSession: null,
                    notes: deleteReason,
                    status: "delete",
                    date: moment(),
                    who: userObject?.userName,
                }

                if(operationTmp.overseeingConsultant) {
                    operationTmp.overseeingConsultant = {
                        id: operationTmp.overseeingConsultant.id,
                        name: operationTmp.overseeingConsultant.name,
                    }
                }

                API.admissionUpdate(operationTmp, signalSubmit.signal).then(
                    (res) => {
                        loadWorklistOperations();
                        dispatch(setSnackbar({
                            type: "success",
                            message: "Operation deleted",
                        }));
                        closeConfirmModal()
                    }
                ).catch(error => {
                    dispatch(setSnackbar({
                        type: "error",
                        message: "Operation not deleted",
                    }));
                    closeConfirmModal()
                });
            }
        } else {
            dispatch(setSnackbar({type: "warning", message: "Reason field must have at least 3 characters."}));
        }


    }

    const goToOperation = (operationTmp) => {
        dispatch(handleOperationClick(operationTmp))
    }

    const handleAddToPass = (admission) => {
        let a = admission
        delete a["href"];
        delete a["patient"];
        delete a["type"];

        a.status = "PENDING";

        API.admissionUpdate(a, signalSubmit.signal).then(
            (res) => {
                console.log(res);
                loadWorklistOperations();
                dispatch(setSnackbar({
                    type: "success",
                    message: "Added to PAS",
                }));

            }
        ).catch(error => {
            dispatch(setSnackbar({
                type: "error",
                message: error.message,
            }));
        });
    }

    const addToPassCell = (column,data) => {
        //console.log(column,data);

        return (
            <Tooltip title={data.patient == null ? t("MISSING PATIENT RECORD"): ""}>
                <div>
                    <AgyleButton
                        className={baToggleClasses.baButton_classNamePrimary}
                        onClick={() => {
                            handleAddToPass(data)
                        }}
                        size="small"
                        style={{width: "max-content"}}
                        disabled={isDeletedView || data.patient === null || !dispatch(hasBAPermission(Permissions.BA_CAN_MANAGE_WORKLIST, admissionType))}
                        variant="contained">
                        {t("Add to PAS")}
                    </AgyleButton>
                </div>
            </Tooltip>
        )
    }
    const deleteOperationCell = (column,data) => {
        return (!isDeletedView && <div>
                {data.status === "WORKLIST" &&
                <Tooltip title={data.patient === null ? "MISSING PATIENT RECORD" : ""} placement="top">
                    <div>
                        <IconButton
                            size={"small"}
                            disabled={data.patient === null || !dispatch(hasBAPermission(Permissions.BA_CAN_MANAGE_WORKLIST, admissionType))}
                            onClick={() => {
                                handleOpenConfirmModal(data)
                            }}
                        >
                            <DeleteIcon/>
                        </IconButton>
                    </div>
                </Tooltip>
                }
                {data.status !== "WORKLIST" &&
                    <IconButton
                        size={"small"}
                        onClick={() => {
                            goToOperation(data)
                        }}
                    >
                        <ContentPasteGoIcon/>
                    </IconButton>
                }
            </div>
        )
    }

    const [deleteReason, setDeleteReason] = React.useState("");

    const handleOpenConfirmModal = (op) => {
        setDeleteReason("");
        setOperationToDelete(op);
        openConfirmModal()
    }



    const printCell = (column,data) => {
        return (
            <div>
                <IconButton
                    size={"small"}
                    onClick={() => {
                        dispatch(setMarkedOperation(data))
                        openPrintModal()
                    }}
                >
                    <PrintIcon/>
                </IconButton>
            </div>
        )

    }
    const history = useHistory();

    const handleOpenEditCell = (column,data) => {
        return (
            <div>
                <IconButton
                    size={"small"}
                    onClick={() => {
                        history.push("/createBookAdmission/"+data.patientId.replace("/","_$_")+"/"+data.id);
                    }}
                >
                    <EditIcon/>
                </IconButton>
            </div>
        )
    }

    const priorityColors = (desc) => {
        const priorityCfg = _.find(admissionConfig?.priority, (p) => {
            return p.description.toString().toLowerCase() == desc.toString().toLowerCase();
        })
        if(priorityCfg && priorityCfg.hasOwnProperty("color")){
            return priorityCfg.color;
        } else {
            return "#313233"
        }
    }


    const [timeFormat, setTimeFormat] = useState(false);
    const configBA = useSelector(getConfig);

    useEffect(()=> {
        let timeFormatInMin = configBA?.timeFormatInMinutes;

        if(agylePreference.bookedAdmissions.timeFormatInMinutes !== null)
            timeFormatInMin = agylePreference.bookedAdmissions.timeFormatInMinutes

        setTimeFormat(timeFormatInMin);

    },[agylePreference, configBA])

    const procedureCell = (column,data) => {
        if(data.procedures && data.procedures.length>0) {
            return (<div>{data.procedures.map((procedure,index) => (
                <div className={clsx(classes.procedure,classes.fontInter)} key={Math.random()}>
                    <div className={classes.procedureRowTop}>
                        <div className={classes.procedureSpec}>{procedure?.specialty}</div>
                        <div>{procedure?.__description}</div>
                    </div>
                    <div className={clsx(classes.procedureRowTop, classes.procedureRowTopTime)}>
                        <AccessTimeIcon className={classes.procedureRowTopTimeIcon}/>
                        <div className={classes.fontInter}>{procedureLenString(data.proceduresLen?.[index], timeFormat)}</div>
                    </div>
                </div>
            ))}</div>);
        }
        return (<div></div>);
    }

    const priorityCell = (column,data) => {
        if(data.priority && data.priority.hasOwnProperty("code") && data.priority.hasOwnProperty("description")){
            return (<div className={classes.priorityDescription} style={{background: priorityColors(data.priority.description), color: "white"}}>{data.priority.description}</div>);
        } else {
            return (<div className={classes.priorityDescription} style={{color: "white"}}> N/A </div>);
        }
    }

    const handleClosePrintModal = () => {
        closePrintModal();
        dispatch(setMarkedOperation(null));
    }

    const renderCustomOptionPriority = (c) => {
        return (<MenuItem value={c} key={c.code}> {c.description} </MenuItem>);
    };

    const renderChips = () => {
        return (
            <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 0.5}}>
                {whoCanOperateFilter?.map((value) => (
                    <Chip key={value} color={"primary"} style={{height: 24}}
                          label={value.description}/>
                ))}
            </Box>
        );
    }

    const renderPriorityChips = () => {
        return (
            <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 0.5}}>
                {priorityFilter?.map((value) => (
                    <Chip key={value} color={"primary"} style={{height: 24}}
                          label={value.description}/>
                ))}
            </Box>
        );
    }

    useEffect(() => {
        const handleSearch = (event) => {
            if ((event.ctrlKey || event.metaKey) && event.key === 'f') {

                if(isFiltersModalOpen) closeFiltersModal();
                else openFiltersModal();

                event.preventDefault();
            }
        };

        window.addEventListener('keydown', handleSearch);

        return () => {
            window.removeEventListener('keydown', handleSearch);
        };
    }, [isFiltersModalOpen]);

    const renderFilters = () => {

        return <Grid spacing={2} container style={{ minHeight: '80px'}} alignItems="center" justifyContent={"flex-start"}>
            <Grid item style={{display: 'flex'}}>
                <Typography className={clsx(classes.fontInter,classes.recCountA)}>Worklist - Surgeries</Typography>
                <Typography className={clsx(classes.fontInter,classes.recCount)}>{worklistOperations.length}</Typography>
            </Grid>
            <Grid item >
                <Grid spacing={2} container  alignItems="center" justifyContent={"flex-start"}>
                    {admissionType === admissionViewTypes.THEATRES &&
                    <Grid item >
                        <div style={{minWidth: 210}}>
                        <AdmissionSpecialtiesDropdown
                            name="AdmissionSpecialties"
                            label={"Specialties"}
                            color="primary"
                            size={"small"}
                            multiple
                            inputWithTag
                            value={specialtiesFilter}
                            inputProps={{
                                style: {
                                    borderRadius: 5,
                                },
                            }}
                            onChange={(e) => dispatch(setFilterSpecialityWorklist(e))}
                            placeholder={t("Type to see more records")}
                        />
                        </div>
                    </Grid>
                }
                    <Grid item >
                        <div style={{minWidth: 210}}>
                        <AdmissionConsultantDropdown
                            name="AdmissionConsultant"
                            color="primary"
                            size={"small"}
                            label={t('Overseeing Consultant')}
                            multiple
                            disabed
                            inputWithTag
                            value={ovsConsultantFilter}
                            onChange={(e) => dispatch(setFilterConsultantWorklist(e))}
                            placeholder={t("Type to see more records")}
                        />
                        </div>
                    </Grid>

                    <Grid item >
                        <AgyleMultiselectDropdown
                            label={t('Who Could Operate')}
                            name="wco"
                            showSelectAll={false}
                            comparePath={"code"}
                            optionLabel={"description"}
                            pathToItemValue={"code"}
                            onChange={(newValues) => dispatch(setFilterWhoCanOperateWorklist(newValues))}
                            options={admissionConfig?.whoCouldOperate || []}
                            value={whoCanOperateFilter}
                            size="small"
                            fullObjecValue
                        />


                    </Grid>
                    <Grid item >
                        <div style={{minWidth: 140}}>
                        <AgyleMultiselectDropdown
                            label={t('Priority')}
                            name="priority"
                            showSelectAll={false}
                            showSelectNone={true}
                            optionLabel={"description"}
                            comparePath={"code"}
                            pathToItemValue={"code"}
                            onChange={(newPriority) => dispatch(setFilterPriorityWorklist(newPriority))}
                            options={admissionConfig?.priority || []}
                            value={priorityFilter}
                            size="small"
                            fullWidth
                            fullObjecValue
                        />
                        </div>
                    </Grid>
                    <Grid item>
                        <AgyleTextField
                            onChange={(e)=> {setInput(e.target.value)}}
                            name="patient"
                            value={input}
                            startAdornment={<SearchIcon fontSize={"small"} style={{marginRight: 5}}/>}
                            borderRadius={10}
                            noBorder={false}
                            inputPropsClasses={classes.inputPropsClasses}
                            smallerPlaceholder
                            placeholder={"Patient Search"}
                            size="small"
                            fullWidth
                        />
                    </Grid>

                    <Grid item >
                        <Grid component="label" container alignItems="center" spacing={1}>
                            <Grid item>Active</Grid>
                            <Grid item>
                                <Switch checked={ isDeletedView}
                                        size={"small"}
                                        onChange={()=>{setDeletedView(!isDeletedView)}}
                                        color="primary" />
                            </Grid>
                            <Grid item>Deleted</Grid>
                        </Grid>
                    </Grid>

                    <Grid item >
                        <IconButton
                            onClick={openFiltersModal}
                            size={"small"}
                        >
                            <FilterIcon2/>
                        </IconButton>
                    </Grid>
                    {filtersAreSet() !== 0 && <Grid item>
                        <div className={classes.clearFilterButton} onClick={clearFilters}>
                            <CloseIcon fontSize={"small"}/>
                            Clear Filters
                        </div>
                    </Grid>
                    }
                </Grid>
            </Grid>
        </Grid>
    }

    const TABLE_COLUMNS = [
        createAgyleTableColumn("date", "Date Entered", 1, "_createdDate", "date", "notSort",
            "medium", "left", "custom", false, null, null,["DD/MM/YYYY",{className:clsx(classes.cell,classes.fontRobo)}]),
        createAgyleTableColumn("patient", "Patient Detail", 2, "patientName", "$custom", "notSort",
            "medium", "left", "custom", false, null, null, [patientCell,{className:clsx(classes.cell,classes.fontRobo)}]),
        createAgyleTableColumn("procedure", "Procedure Details", 3, "procedure1.__description", "$custom", "notSort",
            "medium", "left", "custom", false, null, null, [procedureCell,{className:classes.cell}]),
        createAgyleTableColumn("priority", "Priority", 3, "priority.description", "$custom", "notSort",
            "medium", "left", "custom", false, null, null, [priorityCell,{className:classes.cell}]),
        createAgyleTableColumn("notes", "Notes & Allergies", 4, "notes", "string", "notSort",
            "medium", "left", "custom", false, null, 200, [{className:clsx(classes.cell,classes.notes,classes.fontRobo)}]),
        createAgyleTableColumn("whoOperate", "Who Could Op.", 5, "whoCouldOperate.description", "string", "notSort",
            "medium", "left", "custom", false, null, 110,[{className:clsx(classes.cell,classes.fontRobo)}]),
        createAgyleTableColumn("breachDate", "Breach Date", 6, "breachDate18wk", "date", "notSort",
            "medium", "left", "custom", false, null, 110,["DD/MM/YYYY",{className:clsx(classes.cell,classes.fontRobo)}]),
        //createAgyleTableColumn("session", "Oryginal Session", 7, "hospNo", "string", "", "medium", "left", true, true, null, 110),
        createAgyleTableColumn("delete", "", 7, "delete", "$custom", "notSort",
            "medium", "left", "custom", false, null, 50 ,[deleteOperationCell,{className:classes.cell}]),
        createAgyleTableColumn("openEdit", "", 8, "patientId", "$custom", "notSort",
            "medium", "left", "custom", false, null, 50 ,[handleOpenEditCell,{className:classes.cell}]),
        createAgyleTableColumn("print", "", 9, "print", "$custom", "notSort",
            "medium", "left", "custom", false, null, 50 ,[printCell,{className:classes.cell}]),
        createAgyleTableColumn("addToPass", "", 10, "patientId", "$custom", "notSort",
            "medium", "left", "custom", false, null, 50 ,[addToPassCell,{className:classes.cell}]),
    ];
    const sortTypes = [
        {id: 1, field: "_createdDate", order: "desc", label: "Entry Date: Newest"},
        {id: 2, field: "_createdDate", order: "asc", label: "Entry Date: Oldest"},
        {id: 3, field: "priority.code", order: "desc", label: "Priority: Highest", type: "number"},
        {id: 4, field: "priority.code", order: "asc", label: "Priority: Lowest", type: "number"}
    ]

    const [sort, setSort] = React.useState(sortTypes[0]);

    const handleSetSort = (id) => {
        setSort(sortTypes.find((el) => el.id === id));
    }

    const renderCustomOption = (opt) => {
        return (
            <MenuItem
                key={opt.label}
                value={opt.id}
            >
                {opt.label}
            </MenuItem>
        );
    };

    const renderFiltersModalContent = () => {
        return  <div style={{display: "inline-flex", width: "100%", marginBottom: 20, gap: 30, justifyContent: "space-evenly"}}>
            <div style={{ width: "25%"}}>

                <div className={classes.filterName}>Specialties</div>


                <AdmissionSpecialtiesDropdown
                    name="AdmissionSpecialties"
                    label={"Specialties"}
                    color="primary"
                    size={"small"}
                    closeOnSelect
                    multiple
                    value={specialtiesFilter}
                    onlyAddButton
                    addButtonRender={<AgyleTextField fullWidth={true} noBorder={false} variant="outlined" value={""}/>}
                    inputProps={{
                        style: {
                            borderRadius: 5,
                        },
                    }}
                    onChange={(e) => dispatch(setFilterSpecialityWorklist(e))}
                />

                {specialtiesFilter?.map((option) => (
                    <MenuItem key={option?.__id} value={option} onClick={() => {
                        let newSpeciality = [];
                        newSpeciality = specialtiesFilter.filter((el) => el.__id !== option.__id)

                        dispatch(setFilterSpecialityWorklist(newSpeciality));

                    }} className={classes.menuItem}>
                        <Checkbox
                            checked={true}
                            disableRipple
                        />
                        <div> {option.__description} </div>
                    </MenuItem>
                ))}

            </div>
            <div style={{ width: "25%"}}>
                <div className={classes.filterName}>Overseeing Consultant</div>

                <AdmissionConsultantDropdown
                    name="AdmissionConsultant"
                    color="primary"
                    size={"small"}
                    label={t('Overseeing Consultant')}
                    multiple
                    closeOnSelect
                    disabed
                    onlyAddButton
                    addButtonRender={<AgyleTextField fullWidth={true} noBorder={false} variant="outlined" value={""}/>}
                    value={ovsConsultantFilter}
                    onChange={(e) => dispatch(setFilterConsultantWorklist(e))}
                />

                {ovsConsultantFilter?.map((option) => (
                    <MenuItem key={option?.__id} value={option}  onClick={()=>{
                        let newConsultants = [];
                        newConsultants = ovsConsultantFilter.filter((el) => el.name !== option.name)

                        dispatch(setFilterConsultantWorklist(newConsultants));

                    }} className={classes.menuItem}>
                        <Checkbox
                            checked={true}
                            disableRipple
                        />
                        <div> {option.name} </div>
                    </MenuItem>
                ))}

            </div>
            <div style={{ width: "25%"}}>
                <div className={classes.filterName}>Who Could operate</div>

                {admissionConfig?.whoCouldOperate?.map((option) => (
                    <MenuItem key={option?.__id} value={option}
                              onClick={()=>{
                                  let newWhoCanOperate = [];
                                  if(whoCanOperateFilter?.includes(option.code)) newWhoCanOperate = whoCanOperateFilter.filter((el) => el !== option.code)
                                  else newWhoCanOperate = [...whoCanOperateFilter, ...[option.code]];

                                  dispatch(setFilterWhoCanOperateWorklist(newWhoCanOperate));


                              }} className={classes.menuItem}>
                        <Checkbox
                            checked={whoCanOperateFilter?.includes(option.code)}
                            disableRipple
                        />
                        <div> {option.description} </div>
                    </MenuItem>
                ))}
            </div>
            <div style={{ width: "25%"}}>
                <div className={classes.filterName}>Priority</div>
                {admissionConfig?.priority?.map((option) => (
                    <MenuItem key={option?.__id} value={option}
                              onClick={()=>{
                                  let newPriority = [];
                                  if(priorityFilter?.includes(option.code)) newPriority = priorityFilter.filter((el) => el !== option.code)
                                  else newPriority = [...priorityFilter, ...[option.code]];

                                  dispatch(setFilterPriorityWorklist(newPriority));

                              }}
                              className={classes.menuItem}>
                        <Checkbox
                            checked={priorityFilter?.includes(option.code)}
                            disableRipple
                        />
                        <div> {option.description} </div>
                    </MenuItem>
                ))}
            </div>
        </div>
    }
    return (
        <Paper className={classes.paper}>
            <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                <AgyleToggleButtons
                    classNameRoot={baToggleClasses.baToggle_classNameRoot}
                    classNameLabel={baToggleClasses.baToggle_classNameLabel}
                    classNameSelected={baToggleClasses.baToggle_classNameSelected}
                    onChange={ (e) => {
                        if(e) {
                            dispatch(setOperationsStatus(e));
                            dispatch(setMarkedOperation(null))
                        }
                    }}
                    value={props.admissionStatus}
                    size="small"
                    options={[
                        {value: admissionStatusTypes.WORKLIST, label: "Worklist"},
                        {value: admissionStatusTypes.UNSCHEDULED, label: "Unscheduled"},
                        {value: admissionStatusTypes.SCHEDULED, label: "Scheduled"},
                    ]}
                    minWidth={100}
                />
                <div style={{width: 200}}>
                    <AgyleSelectField
                        onChange={handleSetSort}
                        name={"sort"}
                        options={sortTypes}
                        value={sort.id}
                        withBorder
                        withBackground
                        padding={"3px"}
                        defaultClearValue={null}
                        customObject={renderCustomOption}
                        clearButtonVisible={false}
                    />
                </div>

            </div>
            {renderFilters()}

            <AgyleTable
                disableFilter={true}
                columns={TABLE_COLUMNS}
                data={getWorklistOperationsSorted()}
                // data={listData}
                //customizableColumnsPath="bedBookingColumnOrder"
                tableContainerClass={"scroll-normal-white"}
                rowClass={classes.tableRow}
                headerClass={classes.headerRow}
                headerCellClass={classes.headCell}
            />
            {isPrintModalOpen &&
            <HeaderPrintModal
                title={"Print"}
                open={isPrintModalOpen}
                onClose={handleClosePrintModal}
                width={"lg"}
                dialogContentStyle={classes.dialogContentStyle}
                fullWidth
                fullScreen
                disableActions
                closeButtonOnHeader
                onlyPatient
            />}
            {isConfirmModalOpen &&
                <AgyleDialog
                    contentStyle={classes.dialogContentStyle}
                    title={"Please confirm Delete"}
                    open={isConfirmModalOpen}
                    onClose={closeConfirmModal}
                    fullWidth
                    disableActions
                    closeButtonOnHeader
                >
                    <div>
                        <TextField
                            label={"Reason"}
                            name={"Reason"}
                            onChange={(e) => setDeleteReason(e.target.value)}
                            value={deleteReason}
                            fullWidth
                            multiline
                        />
                    </div>
                    <div style={{marginTop: 10, float: "right"}}>
                        <AgyleButton
                            onClick={deleteOperation}
                            variant="contained"
                            disabled={!deleteReason}
                        >
                            Accept
                        </AgyleButton>
                    </div>
            </AgyleDialog>
            }

            {isFiltersModalOpen &&
                <AgyleDialog
                    contentStyle={classes.dialogContentStyle}
                    title={"Filter"}
                    open={isFiltersModalOpen}
                    onClose={closeFiltersModal}
                    fullWidth
                    width={"lg"}
                    disableActions
                    closeButtonOnHeader
                >
                    <div>
                        {renderFiltersModalContent()}
                        {filtersAreSet() !== 0 &&
                        <div style={{justifyContent: "flex-end", display: "flex"}}>
                            <AgyleButton
                                onClick={clearFilters}
                                variant="contained">
                                Clear Filters
                            </AgyleButton>
                        </div>

                        }
                    </div>

                </AgyleDialog>
            }
        </Paper>
    );

};

export default WorkList;